import { ADMIN_RESOURCE_REGISTRY, } from './admin/effective-admin-resource.registry.js';
import { getAdminResourceDescriptor as getReleasedAdminResourceDescriptor, } from './admin/released-admin-resource.registry.js';
import { DATA_RESOURCE_REGISTRY } from './data/data-resource.registry.js';
import { REFERENCE_DATA_RESOURCE_REGISTRY, } from './data/reference-data-resource.registry.js';
/**
 * Resources in this aggregate participate in generic list/table construction.
 * Singleton resources are resolved by the selectors below but are deliberately
 * excluded from this map so they do not need a fabricated table descriptor.
 */
export const HUB_RESOURCE_REGISTRY = Object.freeze({
    ...ADMIN_RESOURCE_REGISTRY,
    ...DATA_RESOURCE_REGISTRY,
    ...REFERENCE_DATA_RESOURCE_REGISTRY,
});
function singletonResource(id) {
    const released = getReleasedAdminResourceDescriptor(id);
    return released && !(id in ADMIN_RESOURCE_REGISTRY)
        ? released
        : undefined;
}
export function getHubResourceById(id) {
    return HUB_RESOURCE_REGISTRY[id] ?? singletonResource(id);
}
export function getHubResourcesByAuthority(authority) {
    const singleton = getReleasedAdminResourceDescriptor('organization-regulatory-profile');
    return [
        ...Object.values(HUB_RESOURCE_REGISTRY),
        ...(singleton ? [singleton] : []),
    ].filter((resource) => resource.authority === authority);
}
function allResources() {
    const singleton = singletonResource('organization-regulatory-profile');
    return [...Object.values(HUB_RESOURCE_REGISTRY), ...(singleton ? [singleton] : [])];
}
export function getHubResourceByListRoute(routeId) {
    return allResources().find((resource) => String(resource.listRouteId) === routeId);
}
export function getHubResourceByDetailRoute(routeId) {
    return allResources().find((resource) => resource.detailRouteId != null && String(resource.detailRouteId) === routeId);
}
export function getHubResourceByCreateRoute(routeId) {
    return allResources().find((resource) => resource.createRouteId != null && String(resource.createRouteId) === routeId);
}
export function getHubResourceByEditRoute(routeId) {
    return allResources().find((resource) => resource.editRouteId != null && String(resource.editRouteId) === routeId);
}
